import { plural } from '@cian/utils';
import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';

import { RangeValue } from 'shared/types/rangeValue';

export function getWorkplaceCountLabel(range?: RangeValue): string | undefined {
  if (!range) {
    return undefined;
  }

  const { max, min } = range;

  if (min && !max) {
    return `от ${numberToPrettyString(min)} ${plural(min, ['места', 'мест', 'мест'])}`;
  }

  if (!min && max) {
    return `до ${numberToPrettyString(max)} ${plural(max, ['места', 'мест', 'мест'])}`;
  }

  if (min && max) {
    return `${numberToPrettyString(min)} - ${numberToPrettyString(max)} ${plural(max, ['место', 'места', 'мест'])}`;
  }

  return undefined;
}
